import React from 'react'
import get from 'lodash/get'
import { withStyles } from "@material-ui/core/styles";


const styles={
    errorStyle:{
        height:"10px",
        color: "#d64332",
        fontWeight: "900",
        maxWidth: "330px",
        fontSize: "12px",
        textAlign: "left",
        fontFamily: "Montserrat,sans-serif"
    }
}
function ErrorTextContainer(props){
    const text=get(props,"text","")
    const classes=get(props,"classes","")

    return (

        <div className={classes.errorStyle}>
            {text !== "" ? text : null}
        </div>
    )
}

export default withStyles(styles)(ErrorTextContainer);